@if (groupedCartItems().length > 0) {
  <section class="max-w-6xl mx-auto p-6">
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div class="lg:col-span-2 mt-2">
        <div class="flex items-center justify-between">
          <h2 class="text-base sm:text-lg md:text-2xl lg:text-3xl font-semibold">
            {{ 'Shopping Cart' | translate }}
          </h2>

          <div class="flex items-center gap-4 text-sm">
            <button
              (click)="shareCart()"
              class="flex items-center gap-2 hover:text-gray-600 transition"
            >
              <sham-i-share-08 />

              <span class="font-medium">{{ 'Share cart' | translate }}</span>
            </button>

            <div class="flex gap-2">
              <a href="#" class="text-[#2596BE]"> <sham-i-telegram /></a>

              <a href="#" class="text-[#2596BE]"><sham-i-messenger /></a>

              <a href="#" class="text-[#2596BE]"><sham-i-whatsapp /></a>
            </div>
          </div>
        </div>
      </div>

      <div class="lg:col-span-2 space-y-6">
        <div class="hidden lg:grid grid-cols-12 items-center p-4 border rounded-lg">
          <div class="col-span-4 flex items-center gap-3">
            <input
              type="checkbox"
              [checked]="allSelected()"
              (change)="toggleGlobalSelectAll($event)"
              class="w-5 h-5 rounded cursor-pointer accent-[#2596BE]"
            />

            <span
              >{{ 'Select all' | translate }} ( {{ selectedItemsCount() }}

              {{ 'items' | translate }} )</span
            >
          </div>

          <div class="col-span-2 text-center">{{ 'Unit Price' | translate }}</div>

          <div class="col-span-2 text-center">{{ 'Quantity' | translate }}</div>

          <div class="col-span-2 text-center">{{ 'Total' | translate }}</div>

          <div class="col-span-2 text-center">{{ 'action' | translate }}</div>
        </div>

        @for (
          store of groupedCartItems();
          track store.seller.sellerId;
          let sIdx = $index
        ) {
          <div class="border rounded-lg overflow-hidden p-4">
            <div
              class="flex items-center justify-between pb-2 border-b border-gray-100"
            >
              <div class="flex items-center gap-3">
                <input
                  type="checkbox"
                  [checked]="isStoreSelected(store)"
                  (change)="toggleStoreSelectAll(sIdx, $event)"
                  class="w-5 h-5 rounded border-gray-300 accent-[#2596BE] cursor-pointer"
                />

                <div class="flex items-center gap-2">
                  <img
                    [src]="mediaUrl(store.seller.sellerLogoUrl)"
                    alt="logo"
                    class="w-7 h-7 rounded-full"
                  />

                  <span class="text-sm text-[#114455]">{{
                    store.seller.sellerName
                  }}</span>
                </div>
              </div>

              <a
                [href]="'seller/' + store.seller.sellerId"
                class="text-[#114455] text-xs font-medium underline"
                >{{ 'view_store' | translate }}</a
              >
            </div>

            <div class="flex flex-col">
              @for (item of store.items; track item.itemId) {
                <!-- DESKTOP -->

                <div
                  class="hidden lg:grid lg:grid-cols-12 items-center px-0 p-4 border-b border-gray-50 gap-4 last:border-none"
                >
                  <!-- PRODUCT -->

                  <div class="col-span-4 flex items-center gap-4">
                    <input
                      type="checkbox"
                      [checked]="isItemSelected(item.itemId)"
                      (change)="toggleSelectItem(item.itemId)"
                      class="w-5 h-5 rounded border-gray-300 accent-[#2596BE] cursor-pointer shrink-0"
                    />

                    <img
                      [src]="mediaUrl(item.imageUrl)"
                      class="w-20 h-20 object-contain shrink-0"
                    />

                    <div class="flex flex-col gap-1">
                      <h4 class="text-base">{{ item.productName }}</h4>

                      <p class="text-sm text-[#424654] font-normal">
                        {{ getOptionsText(item.options) }}
                      </p>
                    </div>
                  </div>

                  <!-- PRICE -->

                  <div class="col-span-2 text-center">
                    <span class="font-medium text-base">
                      {{ item.unitPrice }} {{ item.currency }}</span
                    >
                  </div>

                  <!-- QTY -->

                  <div class="col-span-2 flex justify-center">
                    <app-quantity-selector
                      variant="desktop"
                      [qty]="item.quantity"
                      [itemId]="item.itemId"
                      (decrease)="updateQty(item.itemId, item.quantity, -1)"
                      (increase)="updateQty(item.itemId, item.quantity, 1)"
                    />
                  </div>

                  <!-- TOTAL -->

                  <div class="col-span-2 text-center">
                    <span class="font-medium text-[#2187AB] text-base">
                      {{ item.totalPrice.toFixed(2) }} {{ item.currency }}
                    </span>
                  </div>

                  <div class="col-span-2 flex justify-center gap-2">
                    <!-- ACTIONS -->

                    <app-cart-item-actions
                      [mobile]="false"
                      [favorite]="isFavorite(item.productId, item.variantId)"
                      (toggleFav)="toggleFav(item)"
                      (remove)="removeItem(item.itemId)"
                    />
                  </div>
                </div>

                <!-- MOBILE -->

                <div class="lg:hidden py-5 border-b border-[#E6E6E6]">
                  <div class="flex gap-1 min-w-0 items-start">
                    <!-- checkbox -->

                    <div class="pt-2 shrink-0">
                      <input
                        type="checkbox"
                        [checked]="isItemSelected(item.itemId)"
                        (change)="toggleSelectItem(item.itemId)"
                        class="w-5 h-5 rounded border-gray-300 accent-[#2596BE] cursor-pointer"
                      />
                    </div>

                    <!-- image -->

                    <img
                      [src]="mediaUrl(item.imageUrl)"
                      class="w-10 h-12 object-contain shrink-0"
                    />

                    <div class="flex-1 min-w-0">
                      <h4
                        class="text-xs text-[#333] leading-5 line-clamp-2 break-words"
                      >
                        {{ item.productName }}
                      </h4>
                    </div>

                    <!-- content -->

                    <div class="flex-1">
                      <!-- top -->

                      <div class="flex items-start justify-between gap-3">
                        <!-- title -->

                        <div class="font-medium text-xs">
                          {{ item.unitPrice }} {{ item.currency }}
                        </div>

                        <!-- qty -->

                        <app-quantity-selector
                          variant="mobile"
                          [qty]="item.quantity"
                          [itemId]="item.itemId"
                          (decrease)="updateQty(item.itemId, item.quantity, -1)"
                          (increase)="updateQty(item.itemId, item.quantity, 1)"
                        />
                      </div>

                      <!-- bottom -->

                      <div class="flex items-end justify-between mt-3">
                        <div class="space-y-2">
                          <div class="font-medium text-[#2187AB] text-xs">
                            {{ item.totalPrice.toFixed(2) }} {{ item.currency }}
                          </div>
                        </div>

                        <!-- actions -->

                        <app-cart-item-actions
                          [mobile]="true"
                          [favorite]="isFavorite(item.productId, item.variantId)"
                          (toggleFav)="toggleFav(item)"
                          (remove)="removeItem(item.itemId)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>

            @if (hasSelectedCoupon(store.seller.sellerId)) {
              <div class="pt-3 md:pt-4 border-t border-gray-100">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-2">
                    <span class="text-sm font-medium text-gray-900">
                      {{ 'voucherApplied' | translate }} "{{
                        getAppliedCouponCode(store.seller.sellerId)
                      }}"
                    </span>

                    <button
                      (click)="removeCoupon(store.seller.sellerId)"
                      class="text-sm text-red-600 hover:text-red-800 underline"
                    >
                      {{ 'remove' | translate }}
                    </button>
                  </div>
                </div>

                @if (isCouponUnavailable(store.seller.sellerId)) {
                  <div class="mt-2 text-sm text-red-600">
                    {{ getCouponUnavailableReason(store.seller.sellerId) }}
                  </div>
                }

                <div
                  class="mt-2 flex items-center gap-2 text-[#1E7898] transition hover:underline cursor-pointer"
                  (click)="openVoucherModal(store.seller.sellerId)"
                >
                  <sham-i-leading />

                  <span class="text-sm font-medium">{{
                    'chooseAnotherVoucher' | translate
                  }}</span>
                </div>
              </div>
            } @else {
              @if (store.availableCoupons.length) {
                <div
                  class="pt-3 md:pt-4 border-t border-gray-100 flex items-center gap-2 text-[#1E7898] transition hover:underline cursor-pointer"
                  (click)="openVoucherModal(store.seller.sellerId)"
                >
                  <sham-i-leading />

                  <span class="text-sm font-medium">{{
                    'addShopVoucherCode' | translate
                  }}</span>
                </div>
              } @else {
                <div
                  class="flex items-center gap-2 border-t border-gray-100 pt-3 text-[#6D6D6D] md:pt-4"
                >
                  <sham-i-nocoupon class="text-[#6D6D6D]" />
                  <span class="text-sm font-medium">No Vouchers Available Yet</span>
                </div>
              }
            }
          </div>
        }

        <div class="pt-2">
          <button
            (click)="goBack()"
            class="px-5 py-2.5 rounded-lg bg-[#F2F2F2] flex items-center gap-2 text-white-darkest text-xl hover:text-black hover:bg-gray-200 transition"
          >
            {{ 'Return to store' | translate }}
          </button>
        </div>
      </div>

      <div class="p-6 border rounded-lg space-y-6 h-fit sticky top-6">
        <h3 class="text-xl font-medium">{{ 'Order Summary' | translate }}</h3>

        <div class="space-y-4">
          <div class="flex justify-between text-[#4D4D4D] text-sm">
            <span>{{ 'Subtotal' | translate }}:</span>

            <span class="font-medium"
              >{{ subtotal().toFixed(2) }} {{ currency() }}</span
            >
          </div>

          @if (totalDiscount()) {
            <hr class="border" />
            <div class="flex justify-between text-[#4D4D4D] text-sm">
              <span>{{ 'totalDiscount' | translate }}:</span>

              <span class="font-medium"
                >{{ totalDiscount().toFixed(2) }} {{ currency() }}</span
              >
            </div>
          }

          <hr class="border" />

          <div class="flex justify-between items-center">
            <span class="font-bold text-[#4D4D4D]">{{ 'Total' | translate }}:</span>

            <span class="text-lg font-bold text-[#2596BE]">
              {{ total().toFixed(2) }} {{ currency() }}
            </span>
          </div>
        </div>

        <button
          (click)="checkout()"
          [disabled]="selectedCount() === 0"
          class="w-full bg-[#2596BE] opacity-50 text-[#FEFEFE] py-2 rounded-lg font-normal text-base transition"
          [ngClass]="{
            'hover:bg-[#1a7a9c] opacity-100': selectedCount() !== 0,
          }"
        >
          {{ 'Proceed to Checkout' | translate }} ({{ selectedCount() }})
        </button>
      </div>
    </div>
  </section>

  @for (store of groupedCartItems(); track store.seller.sellerId) {
    <app-shop-voucher-modal
      [isModalOpen]="isVoucherModalOpen()[store.seller.sellerId] || false"
      [sellerStoreId]="store.seller.sellerId"
      [sellerSubtotal]="store.subtotal"
      [currentSelectedCouponId]="store.selectedCoupon?.couponId ?? null"
      [currentSelectedCouponCode]="store.selectedCoupon?.code ?? null"
      [availableCoupons]="store.availableCoupons"
      (couponSelected)="onCouponSelected(store.seller.sellerId, $event)"
      (closed)="closeVoucherModal(store.seller.sellerId)"
    />
  }
} @else {
  <app-empty-page
    [imageSrc]="'/assets/images/carts-empty-state-bg.svg'"
    [message]="'Your cart is empty'"
    [buttonText]="'Continue Shopping'"
    [buttonLink]="'/home'"
  />
}
